// eslint-ignore
export default 
`// Default Input
<Input v-model="text" label="Default">
    <template v-slot:label="data">
        <span>{{ data.item }}</span>
    </template>
</Input>
<p>Value:{{ text }}</p>

// Inline Input
<Input v-model="textInline" label="Inline" inline>
    <template v-slot:label="data">
        <span>{{ data.item }}</span>
    </template>
</Input>
<p>Value:{{ textInline }}</p>


export default {
    components: { Input },
    data () {
      return {
        text:'',
        textInline:'The quick brown fox jumps over the lazy dog'
      }
    }
}`;